module.exports = __webpack_public_path__ + "img/f743e1300b7c6294d415149f82f32bf2.2ad9638c.png";